// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { carouselStyles } from "@insite/content-library/Components/Carousel";
import { swiperButtonStyle } from "@sc/App/Components/XngCarousel";
import { mergeWithCss } from "@sc/XDL/Utilities";
import { css } from "styled-components";

carouselStyles.prevArrowGridItem = {
    ...mergeWithCss(carouselStyles.prevArrowGridItem, {
        css: css`
            position: relative;
        `,
    }),
};

carouselStyles.prevArrowButton = {
    css: css`
        left: 0;
        border-radius: 50%;
        ${swiperButtonStyle};
    `,
};

carouselStyles.nextArrowGridItem = {
    ...mergeWithCss(carouselStyles.nextArrowGridItem, {
        css: css`
            position: relative;
        `,
    }),
};

carouselStyles.nextArrowButton = {
    css: css`
        right: 0;
        border-radius: 50%;
        ${swiperButtonStyle};
    `,
};
